import 'react';
import 'prop-types';
import 'reakit/styled';
import { theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import Pane from '../Pane/index.js';
import '../Text/styled.js';
import Text from '../Text/index.js';

var Card = styled(Pane).withConfig({
  displayName: "styled__Card",
  componentId: "sc-150cbjc-0"
})(["padding:", "rem;&{", ";}"], space(6, 'minor'), theme('fannypack.Card.base'));
var CardContent = styled(Box).withConfig({
  displayName: "styled__CardContent",
  componentId: "sc-150cbjc-1"
})(["&{", ";}"], theme('fannypack.Card.Content.base'));
var CardHeader = styled(Box).withConfig({
  displayName: "styled__CardHeader",
  componentId: "sc-150cbjc-2"
})(["align-items:center;display:flex;flex-wrap:wrap;justify-content:space-between;padding-bottom:", "em;position:relative;width:100%;&{", ";}"], space(4), theme('fannypack.Card.Header.base'));
var CardFooter = styled(Box).withConfig({
  displayName: "styled__CardFooter",
  componentId: "sc-150cbjc-3"
})(["display:flex;padding-top:", "rem;width:100%;&{", ";}"], space(4), theme('fannypack.Card.Footer.base'));
var CardTitle = styled(Text).withConfig({
  displayName: "styled__CardTitle",
  componentId: "sc-150cbjc-4"
})(["font-weight:", ";font-size:", "rem;&{", ";}"], theme('fannypack.fontWeights.semibold'), theme('fannypack.fontSizes.300'), theme('fannypack.Card.Title.base'));

export default Card;
export { Card, CardContent, CardFooter, CardHeader, CardTitle };
